import ActivitiesModule from "./activities";
import ActivitiesReducer from "./redux/activitiesReducer";
import ActivitiesSaga from "./redux/activitiesSaga";

export default {
  Component: ActivitiesModule,
  moduleName: "activities",
  saga: ActivitiesSaga(),
  reducer: ActivitiesReducer
};
